import React from "react"
import Dialog from "material-ui/Dialog"
import FlatButton from "material-ui/FlatButton"
import strings from "../../../localization/strings"
import ChooseHierarchyPicker from "./ChooseHierarchyPicker"
import autobind from "class-autobind"
import { IHierarchyItem } from "../../../models"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import * as userHelper from "../../../helpers/userHelper"
import * as hierarchySettingsActions from "../../../actions/HierarchySettingsActions"
interface IProps {
	getCustomNoAccessErrorStr?(selectedHierarchy: IHierarchyItem): string
	getClickableAccessHierarchies?(): string[]
	getAccessRight?(selectedHierarchy: IHierarchyItem): boolean
	handleClose(): void
	handleSave(selectedHierarchyItem: IHierarchyItem): void
}
interface IState {
	selectedHierarchy: IHierarchyItem
	noAccessErrorText: string
}

export default class ChooseHierarchyPickerDialog extends React.Component<IProps, IState> {
	private defaultNoAccessErrorText = strings.You_cant_access_this_hierarchy_item
	constructor(props: IProps) {
		super(props)
		const selectedHierarchy = HierarchySettingsStore.getSelectedLevelItem() && HierarchySettingsStore.getSelectedLevelItem().Id ?
			HierarchySettingsStore.getSelectedLevelItem() :
			null
		this.state = {
			selectedHierarchy,
			noAccessErrorText: this.getNoAccessErrorText(selectedHierarchy)
		}
		autobind(this)
	}

	getClickableAccessHierarchies() {
		return this.props.getClickableAccessHierarchies ?
			this.props.getClickableAccessHierarchies() :
			userHelper.getSupervisorClickableHierarchyIds()
	}

	checkAccessRight(selectedHierarchy: IHierarchyItem): boolean {
		return this.props.getAccessRight ?
			this.props.getAccessRight(selectedHierarchy) :
			userHelper.getSupervisorAccessPermissionForHierarchy(selectedHierarchy)
	}

	getNoAccessErrorText(selectedHierarchy: IHierarchyItem): string {
		return this.props.getCustomNoAccessErrorStr ?
			this.props.getCustomNoAccessErrorStr(selectedHierarchy) :
			this.checkAccessRight(selectedHierarchy) ?
				null :
				this.defaultNoAccessErrorText
	}

	render() {
		return (
			<Dialog
				open
				title={strings.CHOOSE_HIERARCHY_ITEM}
				style={{ minWidth: 900 }}
				autoScrollBodyContent
				actions={[
					<span style={{ fontSize: 19, marginRight: 75, color: "#F57C00" }}>
						{this.state.noAccessErrorText}
					</span>,
					<FlatButton
						data-intercom-target={"Btn-Close-Hierarchy-Dialog"}
						label={strings.CANCEL}
						secondary
						onTouchTap={() => {
							hierarchySettingsActions.receiveHierarchySelectedItem(HierarchySettingsStore.getGlobalLevelItemFilter())
							this.props.handleClose()
						}}
					/>,
					<FlatButton
						data-intercom-target={"Btn-Save-Selected-Hierarchy"}
						label={strings.OK}
						primary
						onClick={() => {
							hierarchySettingsActions.receiveHierarchySelectedItem(HierarchySettingsStore.getGlobalLevelItemFilter())
							this.props.handleSave(this.state.selectedHierarchy)
							this.props.handleClose()
						}}
						disabled={this.state.noAccessErrorText ? true : false}
					/>
				]}
			>
				<div data-intercom-target={"Hierarchy-Selection-Dialog"} style={{ minHeight: 500 }}>
					<ChooseHierarchyPicker
						selectedHierarchy={this.state.selectedHierarchy}
						handleSelectHierarchyItem={(selectedHierarchy: IHierarchyItem) => {
							selectedHierarchy = selectedHierarchy.Id ? selectedHierarchy : null
							this.setState({
								selectedHierarchy,
								noAccessErrorText: this.getNoAccessErrorText(selectedHierarchy)
							})
						}}
						clickableAccessHierarchies={this.getClickableAccessHierarchies()}
					/>
				</div>
			</Dialog>
		)
	}
}
